/**
 * NoticeList
 * --
 */
import { useState, useEffect } from 'react';
import { Content, Title } from 'components';
import { Button, Table, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import MessageAlert, { strCut } from 'utils';
import moment from 'moment';
import { NoticeApi } from 'api';
import { InquirySubType } from 'constants/InquirySubType';

/**----------------------------------------
 * [Component] 홈 > 매장별 매출 차트
 * ----------------------------------------
 */
const NoticeList = ({ data }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  console.log('data: ', data);

  // JSX: start
  return (
    <>
      <Spin spinning={loading}>
        <Content
          maxWidth={'100%'}
          height={320}
          borderRadius={4}
          // padding={'14px 5px'}
        >
          <Title
            size={5}
            style={{ marginBottom: 12 }}
            subButton={
              <Button
                size="small"
                onClick={() => window.open('/inquiry/list', '_blank')}
              >
                <ExportOutlined /> 문의관리
              </Button>
            }
          >
            답변 대기 문의
          </Title>

          <Table
            bordered
            size="small"
            scroll={{ x: 'max-content', y: 210 }}
            // style={{ height: 300 }}
            pagination={false}
            dataSource={data.slice(0, 10) ?? []}
            columns={[
              {
                title: '등록일(시간)',
                dataIndex: 'created_at',
                width: 200,
                align: 'center',
                render: (v) => moment(v * 1000).format('YYYY-MM-DD (HH:mm:ss)'),
              },
              {
                title: '제목',
                dataIndex: 'inquiry_name',
                width: 380,
                align: 'center',
                render: (v) => strCut(v, 55),
              },
              {
                title: '내용',
                dataIndex: 'inquiry_content',
                width: 450,
                align: 'center',
                render: (v) => strCut(v, 180),
              },
              {
                title: '작성자',
                dataIndex: 'user',
                width: 135,
                align: 'center',
                render: (user) => user.user_name,
              },
              {
                title: '문의유형',
                dataIndex: 'inquiry_sub_type',
                width: 185,
                align: 'center',
                render: (value) => InquirySubType[value]?.label,
              },
            ]}
          />
        </Content>
      </Spin>
    </>
  ); // JSX: end
};

NoticeList.defaultProps = {
  onSelect: () => {},
};
export default NoticeList;
